<template>
  <div class="AccountContent">
    <div class="title">Mon Compte</div>
    <div class="rowCount"><span><strong>Informations</strong></span><br /></div>
    <div class="rowCount">
      <Input v-model="CurrentUser.name" datatype="text" description="Prénom" />
      <Input v-model="CurrentUser.name" datatype="text" description="Nom" />
    </div>
    <div class="rowCount">
      <Input v-model="CurrentUser.email" datatype="email" description="Adresse email" />
      <!-- <Input v-model="user.tel" datatype="tel" description="Téléphone" /> -->
    </div>
    <div class="rowCount">
        <button class="btn_update" @click="show=!show">Modifier mot de passe</button>
   </div>
    <div class="rowCount">
       <div :class="{BoxPassword:this.show===true,desactive:this.show===false}">update password</div>
    </div>
    <div class="rowCount"><span><strong>Options</strong></span></div>
    <div class="rowCount width">
      <Select
        v-model="user.commissions"
        description="Masque les commissions"
        :options="MasqueCommissions"
        label="nom"
      />
    </div>
    <div class="rowCount">
      <button class="btn" @click="UpdateAccount">Modifier</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Input from "./Input";
import Select from "./Select";
export default {
  data() {
    return {
      MasqueCommissions: [
        { nom: "Non", value: "non" },
        { nom: "Oui", value: "oui" },
      ],
      show:false,
      user: {
        prenom: "william",
        nom: "Signes",
        mail: "w.signes@2l-courtage.fr",
        tel: "0769046829",
        commissions: "non",
      },
    };
  },
  components: {
    Input,
    Select,
  },
  methods: {
    UpdateAccount() {
      console.log("update user");
    },
  },
  computed: {
    ...mapGetters(['CurrentUser'])
  }
};
</script>

<style soped lang="scss">
.AccountContent {
  display: inline;
  width: 100%;
  .title {
    width: 100%;
    color: #068596ba;
    font-weight: bold;
    font-size: 25px;
    margin: 10px;
    margin-bottom: 20px;;
  }
  .rowCount {
    display: flex;
    width: 100%;
    span {
        margin-left:8px;
        color:#8d9c9e;
    }
    .btn {
      margin-left: 20px;
      margin-top: 25px;
      background-color: #068596fa;
      color: white;
      border: 1px solid #22a1b9;
      border-radius: 3px;
      height: 30px;
      width: 100px;
      &:focus {
        outline: 0;
      }
      &:hover {
        border-color: #ff8c00;
        background-color: #ff8c00;
      }
    }
    .btn_update{
        text-align: left;
      margin-left: 20px;
      margin-top: 25px;
      background-color: #bfccceba;
      color: #738081;
      font-size:25px;
      border: 1px solid #bfccceba;
      border-radius: 3px;
      height: 60px;
      width: 93%;
      outline: 0;
      margin-bottom: 20px;
    }
    .desactive{
        display: none;
    }
    .BoxPassword{
        margin-top:20px;
        margin-bottom:20px;
        
    }
  }
  .width {
    width: 30%;
  }
}
@media screen and (max-width: 425px) {
.AccountContent{
  .rowCount{
    display: inline;
    width: 95%;
    .btn_update{
      width: 90%;
    }
  } 
}
}
</style>

